'use strict';
angular.module('schoolLinqApp').factory('siteClaimsService', [
	'$http',
	function ($http) {
		var endpoint = '/api/siteClaims';

		function getSiteClaims() {
			return $http.get(endpoint);
		}

		function updateActiveFlag(claims) {
			return $http.put(endpoint + '/updateActiveFlag', claims);
		}

		return {
			getSiteClaims: getSiteClaims,
			updateActiveFlag: updateActiveFlag,
		};
	},
]);
